import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, defineMessages } from 'react-intl';
import Button from '../Button';
import Input from '../Input';
import Grid from '../Grid';
import getCalendarFeedUrl from '../CalendarFeedLink/utils';
import './styles.css';

const messages = defineMessages({
  copyButton: {
    id: 'repvisits.calendarsync.sharecalendar.copy',
    defaultMessage: 'Copy',
  },
});

export default class CalendarFeedTextBoxWithCopyButton extends React.PureComponent {
  static propTypes = {
    token: PropTypes.string,
    copy: PropTypes.func,
  };

  getUrl() {
    const { token } = this.props;
    return getCalendarFeedUrl({ token });
  }

  copyToClipboard = (_) => {
    this.props.copy(this.getUrl());
  };

  render() {
    return (
      <Grid>
        <Grid.Column width={13}>
          <Input data-cy="repvisits-calendar-share-webcal-link" value={this.getUrl()} readOnly="true" styleName="expand" />
        </Grid.Column>
        <Grid.Column width={3}>
          <Button primary onClick={this.copyToClipboard}>
            <FormattedMessage {...messages.copyButton} />
          </Button>
        </Grid.Column>
      </Grid>
    );
  }
}
